import { AccessorsMutatorsDecorator, Model } from "../../helpers";
import { Country } from "./country.model";

/**
 * @class SmsRate
 *
 */
export class SmsRate extends Model {

    static get validationModel() {

        return {
            from: {
                label: '#_OF_SMSS_FROM'
            },
            to: {
                label: '#_OF_SMSS_TO'
            },
        };
    }

    /**
     * @param {Object|Country} value
     * @returns {Country}
     */
    setCountry(value) {

        if (!value) {

            return value;
        }

        return value instanceof Country ? value : new Country(value);
    }
}

AccessorsMutatorsDecorator('id', 'country', 'country_id', 'from', 'to', 'price', 'price_with_vat')(SmsRate);


// WEBPACK FOOTER //
// ./src/pms-api/models/sms-rate.model.js